export default "__VITE_ASSET__BFo$hiVF__"